import { Icon, IconProps } from '@chakra-ui/icons'
import { FC } from 'react'

export const BulletCheck: FC<IconProps> = (props) => {
  return (
    <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none" color="#0B2730" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M.327 1.638C0 2.28 0 3.12 0 4.8v2.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C2.28 12 3.12 12 4.8 12h2.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C12 9.72 12 8.88 12 7.2V4.8c0-1.68 0-2.52-.327-3.162A3 3 0 0 0 10.362.327C9.72 0 8.88 0 7.2 0H4.8C3.12 0 2.28 0 1.638.327A3 3 0 0 0 .327 1.638Zm6.41 6.184 3.292-3.293-1.06-1.06-3.293 3.293a.25.25 0 0 1-.354 0L3.53 4.969l-1.06 1.06 1.793 1.793a1.75 1.75 0 0 0 2.475 0Z"
        clipRule="evenodd"
      />
    </Icon>
  )
}
